// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"g","attrs":{},"children":[{"tag":"path","attrs":{"stroke":"#000","d":"M10.8788 21.6066L2.39355 13.1214L11.5149 4.01475L20.0002 4L20.0002 12.5L10.8788 21.6066Z M15.9966 7.99976H16.0005L16.0005 8.00366L15.9966 8.00366V7.99976Z","strokeWidth":"props.strokeWidth","fill":"none"}}]}]}]},{"tag":"g","attrs":{"id":"tag"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M10.8788 21.6066L2.39355 13.1214L11.5149 4.01475L20.0002 4L20.0002 12.5L10.8788 21.6066Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M10.8788 21.6066L2.39355 13.1214L11.5149 4.01475L20.0002 4L20.0002 12.5L10.8788 21.6066Z M15.9966 7.99976H16.0005L16.0005 8.00366L15.9966 8.00366V7.99976Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const TagIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tag',
    ref,
    icon: element,
  },
));

TagIcon.displayName = 'TagIcon';

export default TagIcon;
